import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameResultsDataStore, gameStore } from '../../../store';

export const ResultsNavigation = observer(() => {
  const { selectResultsByGameTypeId } = gameResultsDataStore;
  const { allGameTypes, activeGameType } = gameStore;
  const [resultsType, setResultType] = useState(activeGameType);

  const selectResultByGameType = (gameTypeId) => {
    selectResultsByGameTypeId(gameTypeId);
    setResultType(gameTypeId);
  };

  useEffect(() => {
    selectResultsByGameTypeId(activeGameType);
    setResultType(activeGameType);
  }, [activeGameType]);

  return (
    <div className='check-resultsBy-type'>
      {allGameTypes.map((gameTypeId, index) => (
        <div title={index + 1} key={gameTypeId} className='check-resultsBy-inner'>
          <div
            onClick={() => selectResultByGameType(gameTypeId)}
            className={`check-resultsBy-ins ${resultsType === gameTypeId ? 'active' : ''} `}
          >
            <p className='check-resultsBy-ins-number'>{index + 1}</p>
          </div>
        </div>
      ))}
    </div>
  );
});
